module.exports = __webpack_public_path__ + "static/media/text-icon.f5a0c519.svg";